import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f91100c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "engage-video-mask"
};
const _hoisted_2 = { class: "engage-video-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_VideoPlayer = _resolveComponent("VideoPlayer");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createBlock(_Transition, { name: "appear" }, {
        default: _withCtx(() => [
            (_ctx.url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("button", {
                            "data-external": "engage-video-close-button",
                            class: "engage-video-close",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                        }, [
                            _createVNode(_component_FriedIcon, {
                                size: _ctx.IconSize.Small,
                                class: "icon",
                                icon: "close"
                            }, null, 8, ["size"])
                        ]),
                        _createVNode(_component_VideoPlayer, {
                            url: _ctx.url,
                            "thumb-url": _ctx.thumbUrl,
                            controls: true,
                            autoplay: true,
                            onTimeupdate: _ctx.handleTimeUpdate,
                            onPause: _ctx.handlePause,
                            onEnded: _ctx.handleEnded
                        }, null, 8, ["url", "thumb-url", "onTimeupdate", "onPause", "onEnded"])
                    ])), [
                        [_directive_click_outside, _ctx.handleClose]
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }));
}
